import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefreshIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12 24.5C8.65 24.5 5.8125 23.3375 3.4875 21.0125C1.1625 18.6875 0 15.85 0 12.5C0 9.15 1.1625 6.3125 3.4875 3.9875C5.8125 1.6625 8.65 0.5 12 0.5C13.725 0.5 15.375 0.856 16.95 1.568C18.525 2.28 19.875 3.299 21 4.625V0.5H24V11H13.5V8H19.8C19 6.6 17.906 5.5 16.518 4.7C15.13 3.9 13.624 3.5 12 3.5C9.5 3.5 7.375 4.375 5.625 6.125C3.875 7.875 3 10 3 12.5C3 15 3.875 17.125 5.625 18.875C7.375 20.625 9.5 21.5 12 21.5C13.925 21.5 15.6625 20.95 17.2125 19.85C18.7625 18.75 19.85 17.3 20.475 15.5H23.625C22.925 18.15 21.5 20.3125 19.35 21.9875C17.2 23.6625 14.75 24.5 12 24.5Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgRefreshIcon);
export { ForwardRef as ReactComponent };
